enum Status
{
    TEST_DRAFT      = 20,
    TEST_PENDING    = 21,
    TEST_START      = 22,
    TEST_ABORT      = 23,
    TEST_FINISH     = 24
}

export default Status
